/**
 * The scoring controls on a card, in study mode only. A fieldset after Trace,
 * structurally apart from evidence and signals; every control is a select over
 * a closed set, so nothing typed can end up in the export.
 */
import type { LedgerItem } from '@cordelia/core'
import { fieldsFor } from './fields.js'
import type { Judgment, ScoreField } from './fields.js'
import styles from './Scoring.module.scss'

export type ScoringProps = {
  readonly item: LedgerItem
  readonly value: Judgment | undefined
  readonly onScore: (field: ScoreField, value: string) => void
}

export function Scoring({ item, value, onScore }: ScoringProps) {
  return (
    <fieldset className={styles.score}>
      <legend>Score this card</legend>
      {fieldsFor(item).map((spec) => {
        const id = `${item.id}-${spec.field}`
        return (
          <div className={styles.row} key={spec.field}>
            <label htmlFor={id}>{spec.label}</label>
            <select
              id={id}
              value={value?.[spec.field] ?? ''}
              onChange={(e) => onScore(spec.field, e.currentTarget.value)}
            >
              <option value="">—</option>
              {spec.options.map(([v, label]) => (
                <option key={v} value={v}>
                  {label}
                </option>
              ))}
            </select>
          </div>
        )
      })}
    </fieldset>
  )
}
